import state from './moduleOrderState'
import actions from './moduleOrderActions'
import getters from './moduleOrderGetters'
import mutations from './moduleOrderMutations'

export default {
    namespaced: true,
    isRegistered: false,

    state: state,
    actions: actions,
    getters: getters,
    mutations: mutations
}